import type { Template } from "@/types";

export const LA_07_H4_V3: Template[] = [
    {
        id: "la-07-h4v3-01",
        name: "LA 01 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_01.png",
        size: [1352, 541],
        style: {},
        slots: [          
            { id: "1", x: 92, y: 97, width: 242, height: 170, rotation: 0, imageRotation: 0 },
            { id: "2", x: 92, y: 275, width: 242, height: 170, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 97, width: 241, height: 170, rotation: 0, imageRotation: 0 },
            { id: "4", x: 342, y: 275, width: 241, height: 170, rotation: 0, imageRotation: 0 },
            { id: "5", x: 787, y: 41, width: 306, height: 457, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1101, y: 41, width: 140, height: 224, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1101, y: 274, width: 140, height: 224, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h4v3-02",
        name: "LA 02 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_02.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 92, y: 43, width: 491, height: 334, rotation: 0, imageRotation: 0 },
            { id: "2", x: 92, y: 384, width: 159, height: 115, rotation: 0, imageRotation: 0 },
            { id: "3", x: 259, y: 384, width: 158, height: 115, rotation: 0, imageRotation: 0 },
            { id: "4", x: 425, y: 384, width: 158, height: 115, rotation: 0, imageRotation: 0 },
            { id: "5", x: 787, y: 43, width: 306, height: 457, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1101, y: 43, width: 140, height: 225, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1101, y: 276, width: 140, height: 224, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h4v3-03",
        name: "LA 03 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_03.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 114, y: 56, width: 448, height: 281, rotation: 0, imageRotation: 0 },
            { id: "2", x: 114, y: 345, width: 221, height: 142, rotation: 0, imageRotation: 0 },
            { id: "3", x: 343, y: 345, width: 220, height: 142, rotation: 0, imageRotation: 0 },
            { id: "4", x: 816, y: 56, width: 396, height: 233, rotation: 0, imageRotation: 0 },
            { id: "5", x: 816, y: 297, width: 127, height: 190, rotation: 0, imageRotation: 0 },
            { id: "6", x: 951, y: 297, width: 127, height: 190, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1086, y: 297, width: 126, height: 190, rotation: 0, imageRotation: 0 }    
        ],
    },

    {
        id: "la-07-h4v3-04",
        name: "LA 04 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_04.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 132, y: 54, width: 133, height: 212, rotation: 0, imageRotation: 0 },
            { id: "2", x: 132, y: 274, width: 133, height: 212, rotation: 0, imageRotation: 0 },
            { id: "3", x: 273, y: 54, width: 271, height: 432, rotation: 0, imageRotation: 0 },
            { id: "4", x: 774, y: 54, width: 480, height: 301, rotation: 0, imageRotation: 0 },          
            { id: "5", x: 774, y: 363, width: 155, height: 123, rotation: 0, imageRotation: 0 },
            { id: "6", x: 937, y: 363, width: 155, height: 123, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1100, y: 363, width: 154, height: 123, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h4v3-05",
        name: "LA 05 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_05.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 115, y: 55, width: 220, height: 143, rotation: 0, imageRotation: 0 },
            { id: "2", x: 115, y: 206, width: 447, height: 281, rotation: 0, imageRotation: 0 },
            { id: "3", x: 343, y: 55, width: 220, height: 143, rotation: 0, imageRotation: 0 },
            { id: "4", x: 816, y: 55, width: 396, height: 234, rotation: 0, imageRotation: 0 },
            { id: "5", x: 816, y: 297, width: 127, height: 190, rotation: 0, imageRotation: 0 },
            { id: "6", x: 951, y: 297, width: 127, height: 190, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1086, y: 297, width: 126, height: 190, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h4v3-06",
        name: "LA 06 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_06.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 98, y: 54, width: 480, height: 301, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 98, y: 363, width: 155, height: 123, rotation: 0, imageRotation: 0 },
            { id: "3", x: 261, y: 363, width: 155, height: 123, rotation: 0, imageRotation: 0 },
            { id: "4", x: 424, y: 363, width: 154, height: 123, rotation: 0, imageRotation: 0 },
            { id: "5", x: 791, y: 54, width: 288, height: 432, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1087, y: 54, width: 147, height: 212, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1087, y: 274, width: 147, height: 212, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h4v3-07",
        name: "LA 07 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_07.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 43, y: 55, width: 589, height: 431, rotation: 0, imageRotation: 0 },           
            { id: "2", x: 719, y: 55, width: 194, height: 139, rotation: 0, imageRotation: 0 },
            { id: "3", x: 719, y: 202, width: 194, height: 139, rotation: 0, imageRotation: 0 },
            { id: "4", x: 719, y: 349, width: 194, height: 138, rotation: 0, imageRotation: 0 },
            { id: "5", x: 921, y: 55, width: 258, height: 432, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1187, y: 55, width: 122, height: 212, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1187, y: 275, width: 122, height: 212, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h4v3-08",
        name: "LA 08 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_08.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 64, width: 247, height: 413, rotation: 0, imageRotation: 0 },           
            { id: "2", x: 255, y: 64, width: 285, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 255, y: 275, width: 285, height: 202, rotation: 0, imageRotation: 0 },
            { id: "4", x: 548, y: 64, width: 257, height: 413, rotation: 0, imageRotation: 0 },    
            { id: "5", x: 813, y: 64, width: 285, height: 203, rotation: 0, imageRotation: 0 },
            { id: "6", x: 813, y: 275, width: 285, height: 202, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1106, y: 64, width: 246, height: 413, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h4v3-09",
        name: "LA 09 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_09.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 64, width: 285, height: 203, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 275, width: 285, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 293, y: 64, width: 251, height: 414, rotation: 0, imageRotation: 0 },
            { id: "4", x: 552, y: 64, width: 250, height: 414, rotation: 0, imageRotation: 0 },
            { id: "5", x: 810, y: 64, width: 250, height: 414, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1068, y: 64, width: 284, height: 203, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1068, y: 275, width: 284, height: 203, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h4v3-10",
        name: "LA 10 - H4V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h4_v3_10.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 120, width: 409, height: 302, rotation: 0, imageRotation: 0 },           
            { id: "2", x: 417, y: 120, width: 104, height: 147, rotation: 0, imageRotation: 0 },
            { id: "3", x: 417, y: 275, width: 104, height: 147, rotation: 0, imageRotation: 0 },
            { id: "4", x: 529, y: 120, width: 214, height: 302, rotation: 0, imageRotation: 0 },        
            { id: "5", x: 751, y: 120, width: 188, height: 147, rotation: 0, imageRotation: 0 },
            { id: "6", x: 751, y: 275, width: 188, height: 147, rotation: 0, imageRotation: 0 },
            { id: "7", x: 947, y: 120, width: 408, height: 302, rotation: 0, imageRotation: 0 }
        ],
    }
];